import { RequirementType } from "@wingspanhq/payments/dist/interfaces";

export const selectorHasPayoutMethodRequirement = (
  requirements: { requirementType: RequirementType }[]
): boolean => {
  if (requirements.length === 0) {
    return true;
  }

  return requirements.some(
    e => e.requirementType === ("PayoutMethod" as RequirementType)
  );
};
